import { z } from "zod";
import { VariableSchema } from "./Variable";

export const UpdateVariableRequestSchema = VariableSchema.pick({
  name: true,
  unit: true,
  constraintText: true,
  isLookup: true,
  lookupTableId: true,
}).extend({
  categoryIds: z.array(z.number().positive().min(1)).optional(),
})

export type UpdateVariableRequest = z.infer<typeof UpdateVariableRequestSchema>;
